"use strict";
var $ = (function(){try{return require('jquery')}catch(e){return window.jQuery}})();
var root = module.exports = function(queryResponse) {
  return require("./dlv.js")(queryResponse, ",");
};
